export const CkEditor = {
    Toolbar: {
        Basic: 'basic',
        Normal: 'normal',
        Complete: 'complete',
    }
};